export function ariaBool(value: boolean) {
  return value ? 'true' : 'false';
}
